import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';

export const EncryptionInterceptor: HttpInterceptorFn = (req, next) => {

  const router = inject(Router);

  const portalTimezone = sessionStorage.getItem('timezone');
  const token = sessionStorage.getItem('access_token');

  let modifiedReq = req;

  const isLoginRequest = req.url.includes('login');

  if (!isLoginRequest && !token && !portalTimezone) {
    router.navigate(['/login']);
    return next(req);
  }

  if (token) {
    modifiedReq = modifiedReq.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });
  }

  // if (modifiedReq.method === 'POST' && modifiedReq.body) {
  //   modifiedReq = modifiedReq.clone({
  //     body: {
  //       ency: apiService.encryptPayload(modifiedReq.body)
  //     }
  //   });
  // }

  return next(modifiedReq);
};
